import React from "react";
import { Sparkles } from "lucide-react";

type Props = {
  className?: string;
  size?: number;
};

export default function IconSparkles({ className, size = 16 }: Props) {
  return <Sparkles className={className} width={size} height={size} />;
}


